export default "<app-header></app-header>\n<app-table-utils></app-table-utils>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"